import { useMemo } from 'react';

interface InfoBoxProps {
  list: {
    title: string;
    key: string;
    value: string | React.ReactNode;
  }[];
}

export const InfoBox = (props: InfoBoxProps) => {
  const { list } = props;

  const validList = useMemo(() => {
    return list.filter((item) => !!item?.value);
  }, [list]);

  if (validList.length === 0) {
    return null;
  }

  return (
    <div className="grid grid-cols-3 gap-3">
      {validList.map((item) => (
        <div className="flex flex-col gap-1.5" key={item.key}>
          <div className="text-[var(--fett-text-tertiary)]">{item.title}</div>
          <div className="text-[var(--fett-text-primary)]">{item.value}</div>
        </div>
      ))}
    </div>
  );
};
